import { createBrowserHistory } from 'history'
import { connectRouter, routerMiddleware } from 'connected-react-router'

export const history = createBrowserHistory()
export const routerHistoryMiddleware = routerMiddleware(history)

export default connectRouter(history)
